export const MENU_FONT_DEFS = [
  { id: 'barlowCondensed', family: 'Barlow Condensed', weight: '400' },
  { id: 'truculenta', family: 'Truculenta', weight: '400' },
  { id: 'loveYa', family: 'Love Ya Like A Sister', weight: '400' },
  { id: 'hindMadurai', family: 'Hind Madurai', weight: '400' },
  { id: 'grenze', family: 'Grenze Gotisch', weight: '400' },
  { id: 'edu', family: 'Edu NSW ACT Foundation', weight: '400' },
  { id: 'caesarDressing', family: 'Caesar Dressing', weight: '400' },
  { id: 'dancingScript', family: 'Dancing Script', weight: '400' },
  { id: 'stickNoBills', family: 'Stick No Bills', weight: '400' },
  { id: 'allan', family: 'Allan', weight: '400' },
  { id: 'oregano', family: 'Oregano', weight: '400' },
  { id: 'sunshiney', family: 'Sunshiney', weight: '400' },
  { id: 'snippet', family: 'Snippet', weight: '400' },
  { id: 'ranga', family: 'Ranga', weight: '400' },
  { id: 'englebert', family: 'Englebert', weight: '400' },
  { id: 'playfairDisplay', family: 'Playfair Display', weight: '400' },
  { id: 'lora', family: 'Lora', weight: '400' },
  { id: 'cinzel', family: 'Cinzel', weight: '400' },
  { id: 'caveat', family: 'Caveat', weight: '400' },
  { id: 'courgette', family: 'Courgette', weight: '400' },
  { id: 'cormorantGaramond', family: 'Cormorant Garamond', weight: '400' },
  { id: 'marcellus', family: 'Marcellus', weight: '400' },
  { id: 'ptSerif', family: 'PT Serif', weight: '400' },
  { id: 'poiretOne', family: 'Poiret One', weight: '400' },
  { id: 'bebasNeue', family: 'Bebas Neue', weight: '400' },
  { id: 'kaushanScript', family: 'Kaushan Script', weight: '400' },
  { id: 'satisfy', family: 'Satisfy', weight: '400' },
  { id: 'philosopher', family: 'Philosopher', weight: '400' },
  { id: 'josefinSans', family: 'Josefin Sans', weight: '400' },
  { id: 'volkhov', family: 'Volkhov', weight: '400' }
] as const

export type MenuFontId = typeof MENU_FONT_DEFS[number]['id']

// Conjunto de caracteres reales que aparecen en cartas (es/en/fr/ca/de/eu):
// tildes castellanas (á é í ó ú ñ ü ç ¿ ¡) + cobertura Latin-1 completa + €.
export const REQUIRED_MENU_GLYPHS = 'áéíóúñüç¿¡àèìòùâêîôûäëïöãõåæœßø€'

// Fuentes retiradas: no soportan el conjunto completo de glifos. Se quitan del
// selector, pero se mantienen en menuFonts/FontId/enum para que los bares que
// ya las tienen sigan funcionando.
export const retiredMenuFontIds = ['edu', 'allan'] as const
export type RetiredMenuFontId = typeof retiredMenuFontIds[number]
export type SafeMenuFontId = Exclude<MenuFontId, RetiredMenuFontId>

export const safeMenuFontIds: SafeMenuFontId[] = MENU_FONT_DEFS
  .filter(def => !retiredMenuFontIds.includes(def.id as RetiredMenuFontId))
  .map(def => def.id as SafeMenuFontId)

export const isSafeMenuFont = (id: string): id is SafeMenuFontId =>
  (safeMenuFontIds as readonly string[]).includes(id)

// Resuelve la fuente a usar para el PDF / selector: prioriza la solicitada,
// luego la del bar si es segura, y cae a barlowCondensed.
export function resolveSafeMenuFont (fontFamily: string | null | undefined, barFont?: string | null): SafeMenuFontId {
  if (fontFamily && isSafeMenuFont(fontFamily)) return fontFamily
  if (barFont && isSafeMenuFont(barFont)) return barFont
  return 'barlowCondensed'
}